<template>
  <div class="flex">
    <div><strong>{{ record.projectTitle }}</strong></div>
    <div v-for="t in record" class="change_block">
      <div>
        <span :class="{'btn btn-outline-primary': true, 'active': +t.task.is_active}">A</span>
        <span :class="{'btn btn-outline-primary': true, 'active': +t.task.order_allow}">З</span>
        <span class="price_span">кол. <strong>{{ t.task.qty }}</strong>: <strong>{{ t.task.price }}</strong>
                ({{ t.profitTask }}%)
      </span>
      </div>
      <div class="actual_data">
        <span :class="{'btn btn-outline-primary': true, 'active': +t.actualData.is_active}">A</span>
        <span :class="{'btn btn-outline-primary': true, 'active': +t.actualData.order_allow}">З</span>
        <span class="price_span">кол. <strong>{{ t.actualData.qty }}</strong>: <strong>{{ t.actualData.price }}</strong>
                ({{ t.profitActual }}%)
      </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['record']
}

</script>

<style scoped>
.change_block {
  display: flex;
}

.flex div {
  margin-right: 5px;
}

.change_block .btn {
  font-size: 12px;
  padding: 4px 6px !important;
}

.price_span {
  margin-right: 3px;
  border: 1px solid lightgray;
  padding: 3px;
}

.actual_data {
  opacity: .5;
}
</style>
